<script>
import CountryAPI from "$vueCommon/classes/API/CountryAPI.js";

export default {
    props: {
        selected: Object,
        selectedId: Number,
        placeholder: String
    },
    emits: [
        'onSelected'
    ],
    mounted() {
        CountryAPI.getCountries().then(() => {
            this.countries = CountryAPI.toArray().sort((countryA, countryB) => {
                return countryA.name.localeCompare(countryB.name);
            });

            this.localSelected = this.selected;
            if (this.selectedId) {
                this.localSelected = this.countries.find(country => country.id === this.selectedId);
            }
        });
    },
    data() {
        return {
            countries: [],
            localSelected: {}
        }
    },
    methods: {
        test() {
            alert('test');
        },
        getCss(option) {
            if (option && option.iso_code) {
                return 'flag-xs-' + option.iso_code.toLowerCase();
            }
            return '';
        }
    },
    computed: {
        localPlaceholder() {
            if (this.placeholder) {
                return this.placeholder;
            }

            return this.$translate('auth.country');
        }
    }
}
</script>
<template>
    <div class="component-select-country">
        <div class="input-group">
            <div class="input-group-text">
                <i class="fas fa-map-marker-alt fa-fw"></i>
            </div>
            <div class="form-floating static" :class="{'is-active': localSelected}">
                <vselect v-model="localSelected" label="name" :options="countries" :clearable="false" :searchable="true"
                         :placeholder="localPlaceholder"
                         :selected="$emit('onSelected', localSelected)">
                    <template v-slot:option="option">
                        <div class="flag flag-xs" :class="[getCss(option)]"></div>{{ option.name }}
                    </template>
                    <template v-slot:selected-option="option">
                        <div class="flag flag-xs" :class="[getCss(option)]"></div>{{ option.name }}
                    </template>
                </vselect>
                <label>{{ localPlaceholder }}</label>
            </div>
        </div>
    </div>
</template>
